"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var fieldContainer = /*#__PURE__*/(0, _react.css)("max-width:", (0, _util.rem)(320), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:fieldContainer;"));
var borderRadius = (0, _util.rem)(6);
var fieldPadding = "".concat((0, _util.rem)(8), " ").concat((0, _util.rem)(12), " ").concat((0, _util.rem)(9));

var labelBox = function labelBox(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;font-size:", theme.fontSize.base, ";font-weight:", theme.fontWeight.medium, ";line-height:", theme.lineHeight.leadingNormal, ";color:", theme.color.monochrome.black, ";margin-bottom:", (0, _util.rem)(7), ";label{margin-right:", (0, _util.rem)(4), ";+*:focus{outline:none;}}svg{display:flex;width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";color:", theme.color.primary.brand, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:labelBox;"));
};

var pswIcon = function pswIcon(theme) {
  return /*#__PURE__*/(0, _react.css)("cursor:pointer;flex-shrink:0;display:flex;align-items:center;margin:0 ", (0, _util.rem)(12), ";color:", theme.color.monochrome.mediumDark, ";transition:color 0.2s;svg{width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";}&:hover{color:", theme.color.monochrome.dark, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:pswIcon;"));
};

var borderBrand = function borderBrand(theme) {
  return /*#__PURE__*/(0, _react.css)("border-color:", theme.color.primary.brand, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderBrand;"));
};

var error = function error(theme) {
  return /*#__PURE__*/(0, _react.css)("border-color:", theme.color.primary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:error;"));
};

var invalid = function invalid(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.light, ";pointer-events:none;svg{opacity:0.5;}" + (process.env.NODE_ENV === "production" ? "" : ";label:invalid;"));
};

var formControlStyle = function formControlStyle(_ref2) {
  var theme = _ref2.theme,
      focused = _ref2.focused,
      validateStatus = _ref2.validateStatus,
      disabled = _ref2.disabled;
  return /*#__PURE__*/(0, _react.css)("border:1px solid ", theme.color.monochrome.medium, ";display:flex;border-radius:", borderRadius, ";transition:all 0.2s;background-color:", theme.color.monochrome.white, ";", validateStatus === 'error' && error(theme), ";&:hover{", borderBrand(theme), ";}", focused && borderBrand(theme), ";", disabled && invalid(theme), ";input,textarea{width:100%;border:none;flex-grow:1;font-size:", theme.fontSize.large, ";line-height:", theme.lineHeight.leadingNormal, ";color:", theme.color.monochrome.black, ";padding:", fieldPadding, ";background-color:transparent;border-radius:", borderRadius, ";&::placeholder{color:", theme.color.monochrome.mediumDark, ";}&:focus{outline:none;}&:read-only:not(:disabled){color:", theme.color.monochrome.mediumDark, ";}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus{box-shadow:0 0 0px 1000px transparent inset;transition:background-color 5000s ease-in-out 0s;}}input[type='number']{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;}input[type='number']::-webkit-inner-spin-button,input[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:formControlStyle;"));
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1r7keks",
  styles: "order:1"
} : {
  name: "1dvle6v-tagStyle",
  styles: "order:1;label:tagStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var tagStyle = function tagStyle(_ref3) {
  var tagPosition = _ref3.tagPosition,
      tagContent = _ref3.tagContent,
      theme = _ref3.theme;
  return /*#__PURE__*/(0, _react.css)("display:flex;justify-content:center;align-items:center;padding:0 ", (0, _util.rem)(16), ";background-color:", theme.color.monochrome.light, ";font-size:", theme.fontSize.large, ";line-height:", theme.lineHeight.leadingNormal, ";border-top-left-radius:", tagPosition === 'right' ? 0 : borderRadius, ";border-top-right-radius:", tagPosition === 'left' ? 0 : borderRadius, ";border-bottom-left-radius:", tagPosition === 'right' ? 0 : borderRadius, ";border-bottom-right-radius:", tagPosition === 'left' ? 0 : borderRadius, ";", tagPosition === 'right' && _ref, " ", typeof tagContent !== 'string' && /*#__PURE__*/(0, _react.css)("padding:0 ", theme.spacing[7], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:tagStyle;")), " label{margin-right:0;}svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";}button{margin:0 -", theme.spacing[7], ";padding:0 ", theme.spacing[7], ";height:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:tagStyle;"));
};

var innerButton = /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;pointer-events:initial;margin:-1px;&>button{height:100%;min-width:", (0, _util.rem)(92), ";border-radius:", borderRadius, ";border-top-left-radius:0;border-bottom-left-radius:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:innerButton;"));
var styles = {
  tagStyle: tagStyle,
  innerButton: innerButton,
  fieldContainer: fieldContainer,
  labelBox: labelBox,
  pswIcon: pswIcon,
  formControlStyle: formControlStyle,
  fieldPadding: fieldPadding
};
exports.styles = styles;
//# sourceMappingURL=Field.styles.js.map